import { render, staticRenderFns } from "./SupportTicketTable.vue?vue&type=template&id=1b205bff&"
import script from "./SupportTicketTable.vue?vue&type=script&lang=js&"
export * from "./SupportTicketTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports